import React, { SVGProps } from 'react';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { Icon as IconComponent } from '../Icon';

// Ignore styled-components and React CSS prop clash
const PlayBlobPath = ({
  // @ts-ignore: Property 'css' does not exist
  css: cssProp,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="121"
    height="115"
    viewBox="0 0 121 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // @ts-ignore: Property 'css' does not exist
    // eslint-disable-next-line react/no-unknown-property
    css={cssProp}
    {...props}
  >
    <path
      d="M61.8631 0.000257041C86.6177 -0.067481 108.869 13.2561 116.879 36.332C124.888 59.4079 119.456 87.053 101.473 100.78C83.4904 114.506 63.945 116.513 43.7563 112.03C23.5677 107.547 13.6611 94.4371 8.50465 86.5345C0.216091 73.8317 -3.45691 50.2853 6.60223 30.6488C16.6614 11.0123 37.1085 0.0679951 61.8631 0.000257041Z"
      fill="#FCFAF2"
      fillOpacity="0.5"
    />
  </svg>
);

export const PlayBlob = styled(PlayBlobPath)(
  () => css`
    height: 100%;
    width: 100%;
  `,
);

export const Container = styled.div(
  () => css`
    display: inline-block;
    height: fit-content;
    position: relative;
  `,
);

export const Icon = styled(IconComponent)(
  ({ theme }) => css`
    & svg {
      height: 100%;
      width: 100%;
    }
    & svg * {
      fill: ${theme.co.primary20};
    }
  `,
);

export const PlayBlobContainer = styled.div(
  () => css`
    height: 100%;
    position: relative;
    width: 100%;
  `,
);

export const PlayIconContainer = styled.div(
  () => css`
    /*! @noflip */
    left: 42%;
    position: absolute;
    width: 20%;
  `,
);

export const PlayButton = styled(motion.button)(
  ({ theme }) => css`
    align-items: center;
    background: none;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding: 20%;
    position: absolute;
    top: 0;
    transform-origin: center;
    width: 100%;

    /* The blob is blobby, the button is round.
    To avoid the round button focus state clashing with the
    blob, we only show a border on the blob. */
    &&:focus {
      box-shadow: none;
    }
    &&:focus ${PlayBlob} {
      stroke: ${theme.co.information50};

      stroke-width: 3px;
    }

    & ${Icon}, & ${PlayBlob} {
      transition: transform 0.4s cubic-bezier(0.39, -0.64, 0.29, 2.64);
    }

    &:hover ${Icon}, &:hover ${PlayBlob} {
      transform: scale(1.07);
    }
  `,
);

PlayButton.defaultProps = {
  initial: { scale: 1.4, opacity: 0 },
  animate: { scale: 1, opacity: 1, transition: { duration: 0.1 } },
  exit: { scale: 1.6, opacity: 0, transition: { duration: 0.2 } },
};

export const Video = styled.video`
  border-radius: ${({ theme }) => theme.sz.s4};
  width: 100%;
`;
